import _objectDestructuringEmpty from "@babel/runtime/helpers/esm/objectDestructuringEmpty";
import { Component } from 'react';
import { trackEvent } from '../../../usage-tracking/clients/usageTracker';
import { getInboxZeroState } from '../../constants/Events';
import { jsx as _jsx } from "react/jsx-runtime";
const TrackedZeroState = ({
  zeroStateName
}) => ZeroState => {
  class TrackedZeroStateWrapper extends Component {
    componentDidMount() {
      trackEvent(getInboxZeroState({
        subscreen: 'none',
        zeroStateName
      }));
    }
    render() {
      const _this$props = this.props,
        componentProps = Object.assign({}, (_objectDestructuringEmpty(_this$props), _this$props));
      return /*#__PURE__*/_jsx(ZeroState, Object.assign({}, componentProps));
    }
  }
  TrackedZeroStateWrapper.displayName = 'TrackedZeroStateWrapper';
  return TrackedZeroStateWrapper;
};
export default TrackedZeroState;